// Scripts to fire once dom has loaded

import Swiper, { Navigation, Scrollbar } from 'swiper';

Swiper.use([Navigation, Scrollbar]);

document.addEventListener("DOMContentLoaded", () => {
    const swiperHero = new Swiper('.swiper-hero', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
    });

    const swiperVideo = new Swiper('.swiper-video', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
    });

    const swiperProject = new Swiper('.swiper-project', {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 'auto',
        allowTouchMove: false,

        breakpoints: {
            1024: {
                spaceBetween: 24,
            },
        },

        navigation: {
            nextEl: '.swiper-button-next-project',
            prevEl: '.swiper-button-prev-project',
        },
    });

    const swiperGallery = new Swiper('.swiper-gallery', {
        cssMode: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // OVERLAY FUNCTIONALITY
    const gallerySections = document.querySelectorAll('.section-gallery');
    const overlayGallery = document.querySelectorAll('.overlay-gallery');
    const close = document.querySelectorAll('.js-close-modal');
    const modal = document.querySelectorAll('.js-modal');
    const app = document.getElementById('app');

    if (gallerySections.length) {
        for (let i = 0; i < gallerySections.length; i++) {
            let overlayTriggers = gallerySections[i].querySelectorAll('.js-open-overlay');

            if (overlayTriggers.length) {
                for (let k = 0; k < overlayTriggers.length; k++) {
                    overlayTriggers[k].addEventListener('click', function (e)      {
                        e.stopPropagation()
                        overlayGallery[i].classList.add('show');

                        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
                        app.style.position = 'fixed';
                        app.style.top = `-${scrollY}`;
                        var slideNumber = this.getAttribute('data-position');
                        if(swiperGallery.length){
                            swiperGallery[i].slideTo(slideNumber,0);
                        }else{
                            swiperGallery.slideTo(slideNumber,0);
                        }
                    });
                }
            }

            close[i].addEventListener('click', function(){
                overlayGallery[i].classList.remove("show");

                const scrollY = app.style.top;
                app.style.position = '';
                app.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            });

            //Closes the modal when the document is clicked
            overlayGallery[i].addEventListener('click', () => {
                overlayGallery[i].classList.remove('show');

                const scrollY = app.style.top;
                app.style.position = '';
                app.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);

            });

            modal[i].addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }

        //Prevents the click event from reaching the document
        app.addEventListener('click', (e) => {
            e.stopPropagation();
        });


        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
        });
    }

});